var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckcareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15266 10.7652L14.2027 2.7152C14.476 2.44181 14.476 1.9986 14.2027 1.72524L13.2127 0.735291C12.9394 0.461934 12.4961 0.461934 12.2228 0.735291L5.6577 7.30037L2.59261 4.23528C2.31926 3.9619 1.87602 3.9619 1.60266 4.23528L0.612732 5.22524C0.339376 5.49862 0.339376 5.94183 0.612732 6.21519L5.16273 10.7652C5.43606 11.0386 5.87928 11.0386 6.15266 10.7652Z",
    fill: "#36B37E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcareer);
export default __webpack_public_path__ + "static/media/Checkcareer.caf05fe729e23ac4cae25fe3c89f222e.svg";
export { ForwardRef as ReactComponent };